import { paths } from './paths';

const SHORT_PLAN_RE = /^\/projects\/([^/]+)\/evaluations\/([^/]+)\/plan\/?$/;
const NESTED_PLAN_RE =
  /^\/project-clients\/([^/]+)\/projects\/([^/]+)\/evaluations\/([^/]+)\/plan\/?$/;

// The offerte editor is a sibling of the plan under the same evaluation, so it
// shares the same breadcrumb trail (Kunden / client / project).
const SHORT_WORKSPACE_RE = /^\/projects\/([^/]+)\/evaluations\/([^/]+)\/(?:plan|offerte)\/?$/;
const NESTED_WORKSPACE_RE =
  /^\/project-clients\/([^/]+)\/projects\/([^/]+)\/evaluations\/([^/]+)\/(?:plan|offerte)\/?$/;

export interface EvaluationPlanPathMatch {
  projectId: string;
  evaluationId: string;
  /** Present when URL is under `/project-clients/.../projects/.../evaluations/.../plan`. */
  projectClientId?: string;
}

function matchEvaluationPath(
  pathname: string,
  nestedRe: RegExp,
  shortRe: RegExp,
): EvaluationPlanPathMatch | null {
  const pathOnly = pathname.split('?')[0] ?? pathname;
  const nested = nestedRe.exec(pathOnly);
  if (nested?.[1] !== undefined && nested[2] !== undefined && nested[3] !== undefined) {
    return {
      projectClientId: nested[1],
      projectId: nested[2],
      evaluationId: nested[3],
    };
  }
  const short = shortRe.exec(pathOnly);
  if (short?.[1] !== undefined && short[2] !== undefined) {
    return { projectId: short[1], evaluationId: short[2] };
  }
  return null;
}

/**
 * Match evaluation plan URLs (flat `/projects/.../plan` or nested under the project route).
 * Query string is ignored.
 */
export function matchEvaluationPlanPath(pathname: string): EvaluationPlanPathMatch | null {
  return matchEvaluationPath(pathname, NESTED_PLAN_RE, SHORT_PLAN_RE);
}

/**
 * Match any evaluation workspace URL (`/plan` or `/offerte`). Both share the
 * project breadcrumb trail; used for breadcrumb rendering, not door commands.
 */
export function matchEvaluationWorkspacePath(pathname: string): EvaluationPlanPathMatch | null {
  return matchEvaluationPath(pathname, NESTED_WORKSPACE_RE, SHORT_WORKSPACE_RE);
}

export function projectClientProjectsHref(projectClientId: string): string {
  return paths.projectClientProjects.replace(':projectClientId', projectClientId);
}

export function projectWorkspaceHref(projectClientId: string, projectId: string): string {
  return paths.projectWorkspace
    .replace(':projectClientId', projectClientId)
    .replace(':projectId', projectId);
}
